import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ASSESSMENTTABLE_URL } from "../service/data";

const initialState = {
  assessmentData: [],
  assessmentDataLoading: false,
  assessmentDataError: null,
  assessmentDataSuccess: false,
};

export const assessmentLists = createAsyncThunk(
  "assessment/assessmentLists",
  async ({ role, email, accessToken }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          // Authorization: accessToken ? `Bearer ${accessToken}` : "",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "*",
        },
      };

      const { data } = await axios.get(
        `${ASSESSMENTTABLE_URL}/${role}`,
        config
      );

      return data;
    } catch (error) {
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const assessmentSlice = createSlice({
  name: "assessment",
  initialState,
  reducers: {
    setAssessment: (state, action) => {
      state.assessmentData = action.payload;
    },
  },
  extraReducers: {
    [assessmentLists.pending]: (state) => {
      state.assessmentDataLoading = true;
      state.assessmentDataError = null;
    },
    [assessmentLists.fulfilled]: (state, { payload }) => {
      state.assessmentDataLoading = false;
      state.assessmentDataSuccess = true;
      state.assessmentData = payload;
    },
    [assessmentLists.rejected]: (state, { payload }) => {
      state.assessmentDataLoading = false;
      state.assessmentDataError = payload;
    },
  },
});

export const { setAssessment } = assessmentSlice.actions;

export default assessmentSlice.reducer;
